import React from 'react'
import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { getAllLeaveType } from '../../../api/LeaveManagement/getLeaveType'
import { useAuthContext } from '../../../hooks'
import { getProjectLeadEmail } from '../../../api/ProjectLeadPerformance/getProjectLeadEmail'
import { applyLeave } from '../../../api/LeaveManagement/applyLeave'
import { Button, Form, Modal } from 'react-bootstrap'
import { getOrgUserLeaveHistory } from '../../../api/LeaveManagement/getOrgUserLeaveHistory'
import { getOrgUserDetails } from '../../../api/users/getOrgUserDetails'
import { toast } from 'react-toastify'
import { leaveTemplate } from '../../../Templates/leaveTemplate'
import { sendEmail } from '../../../api/MailSender/mailSender'

const Index = ({ fetchPto, orgUserPto }: any) => {
  const [show, setShow] = useState(false)
  const [ePto, setEPto] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const auth = useAuthContext()
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm()

  const [user, setUser] = useState<any>([])
  const fetchOrgUser = async () => {
    setUser(
      await getOrgUserDetails(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
      ),
    )
    // console.log('works')
  }
  const [leaveType, setLeaveType] = useState<any>([])
  const fetchLeaveType = async () => {
    setLeaveType(await getAllLeaveType(auth?.userInfo?.orgs[0]?.id))
    // console.log('leave Type works')
  }
  const [tlEmail, setTlEmail] = useState<any>([])
  const fetchOrgUserProjectlead = async () => {
    setTlEmail(
      await getProjectLeadEmail(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
      ),
    )
    // console.log('leave history details')
  }
  const [leaveHistory, setLeaveHistory] = useState<any>([])
  const fetchOrgUserLeaveHistory = async () => {
    setLeaveHistory(
      await getOrgUserLeaveHistory(
        auth?.userInfo?.orgs[0]?.id,
        (auth?.userInfo?.orgs_user_id[0]).toString(),
      ),
    )
    // console.log('leave history details')
  }
  useEffect(() => {
    fetchOrgUser()
    fetchLeaveType()
    fetchOrgUserProjectlead()
    fetchOrgUserLeaveHistory()
  }, [])
  const receiverEmails: any[] = []
  tlEmail?.map((data: any) => {
    return receiverEmails.push(data?.tl_email)
  })

  const handleCreate = async (e: any) => {
    console.debug('data > ', e)
   const res =  await applyLeave(
      auth?.userInfo?.orgs[0]?.id,
      (auth?.userInfo?.orgs_user_id[0]).toString(),
      {
        ...e,
        first_name:
          auth?.userInfo?.first_name + ' ' + auth?.userInfo?.last_name,
        ...e,
        email: receiverEmails?.join(','),
      },
    )
      .then((e) => {
        console.log(e)
        toast.success("leave applied successfully")
      })
      .catch((err) => {
        console.log('====================================')
        console.log(err)
        console.log('====================================')
        toast.error("error in aplying leave")
      })
    console.log(e)

  }

  // const handleCreate = async (e: any) => {
  //   try {
  //     console.debug("data > ", e);
  //     const tempLeaveData = e;
  //     console.log("TEM DATA", tempLeaveData)
  //     const res = await applyLeave(
  //       auth?.userInfo?.orgs[0]?.id,
  //       (auth?.userInfo?.orgs_user_id[0]).toString(),
  //       {
  //         ...e,
  //         first_name: `${auth?.userInfo?.first_name} ${auth?.userInfo?.last_name}`,
  //         email: receiverEmails?.join(","),
  //       }
  //     );

  //     console.log("Leave apply response:", res);
  //     toast.success("Leave applied successfully");
  //     // alert("SSSSSSSSssssssssssssssswwwwwwwwwwwwwwSSSS")


  //     const DeleteReceiverEmails = [...receiverEmails, "mukilam@xbi4.com"];
  //     const emailTemplate = leaveTemplate(auth, tempLeaveData, "Applied");

  //     console.log("Sending email to:", DeleteReceiverEmails);

  //     const emailResponse = await sendEmail("workforce@insytix.com", DeleteReceiverEmails, emailTemplate, `Leave Application`);

  //     console.log("sendEmail response:", emailResponse);

  //   } catch (err) {
  //     console.error("Error in applying leave:", err);
  //     toast.error("Error in applying leave");
  //   }
  // };
  const onSubmit = async (e: any) => {
    console.log('I am Here', e)
    await handleCreate(e)
    fetchPto()
    reset()
    setShow(false)
    await fetchPto()
    await orgUserPto()
  }
  const buttonDisabled = leaveHistory?.[0]?.available_off
  const currentDate = new Date()
  const tenDaysLater = new Date(currentDate)
  tenDaysLater.setDate(currentDate.getDate() + 10)
  const formattedMinDate = tenDaysLater.toISOString().split('T')[0]
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true)
  useEffect(() => {
    // Check if the "reason" field has at least 50 characters
    if (watch('reason')?.length >= 50) {
      setIsSubmitDisabled(false) // Enable the submit button
    } else {
      setIsSubmitDisabled(true) // Disable the submit button
    }
  }, [watch('reason')])
  return (
    <div>
      <Button
        variant="primary"
        onClick={() => (Boolean(buttonDisabled) ? handleShow() : null)}
        className="leave-button"
      // style={{ width: "150px", height: "20px", display: "flex", jus }}
      >
        + Apply PTO
      </Button>
      <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>PTO</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {user?.map((data: any) => {
            return (
              <>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Employee Name: </Form.Label>
                    <Form.Control
                      type="text"
                      value={data?.first_name + ' ' + data?.last_name}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Desigation</Form.Label>
                    <Form.Control type="text" value={data?.role} disabled />
                  </Form.Group>
                  <Form.Label>Type of Leave</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    {...register('leave_type', {})}
                  >
                    <option value="">Select Leave Type</option>
                    {/* {leaveType?.map((data: any) => {
                      if (
                        data?.leave_type == "Emergency-PTO" &&
                        data?.leave_type !== "COMP OFF"
                      ) {
                        return (
                          <option key={data?.id} value={data?.id}>
                            {data?.leave_type}
                          </option>
                        );
                      }
                      return null;


                    })} */}

                    <option value="1">PTO</option>
                  </Form.Select>
                  {/* {errors.leave_type?.message && (
                      <p>{errors.leave_type?.message}</p>
                    )} */}
                  <br></br>
                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label className="date">From:</Form.Label>
                    <input
                      type="date"
                      className="date1"
                      aria-label="from-dtae"
                      min={formattedMinDate} // Set the minimum date
                      {...register('start_date')}
                    />

                    <Form.Label className="date">To :</Form.Label>
                    <input
                      type="date"
                      aria-label="from-dtae"
                      className="date1"
                      min={formattedMinDate}
                      {...register('end_date')}
                    />
                  </Form.Group>

                  <Form.Select
                    aria-label="Default select example"
                    {...register('leave_duration')}
                  >
                    <option value="">Select duration</option>

                    <option value="0.125">1 Hour</option>
                    <option value="0.25">2 Hours</option>
                    <option value=".375">3 Hours</option>
                    <option value="0.5">4 Hours</option>
                    <option value="0.625">5 Hours</option>
                    <option value="0.75">6 Hours</option>
                    <option value="0.875">7 Hours</option>
                    <option value="1">8 Hours</option>
                  </Form.Select>

                  <Form.Group
                    className="mb-3"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Label>Reason</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Example: PTO , WFH , Floating Holiday"
                      {...register('reason')}
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Apply PTO
                  </Button>
                </form>
              </>
            )
          })}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Index
